import { useEffect } from "react";
import HeroSection from "./Sections/HeroSection";
import ProjectsSection from "./Sections/ProjectsSection";
import ServicesSection from "./Sections/ServicesSection";
import AboutUsSection from "./Sections/AboutUsSection";
import ContactUsSection from "./Sections/ContactUsSection";
import FooterSection from "./Sections/FooterSection";
import { Helmet } from "react-helmet";
import { META } from "../../constants/meta";
import ReactGA from 'react-ga4';

const Home = () => {
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/",
      title: "Home Page",
    });

    let rellaxInstance: any = null;
    if (typeof window !== "undefined" && window.Rellax) {
      rellaxInstance = new window.Rellax(".rellax");
    }
    return () => {
      if (rellaxInstance && typeof rellaxInstance.destroy === "function") {
        rellaxInstance.destroy();
      }
    };
  }, []);

  return (
    <main className=" relative bg-black scroll-smooth top-0">
      <Helmet>
        {/* Title */}
        <title>{META.title}</title>

        {/* Primary Meta Tags */}
        <meta name="title" content={META.title} />
        <meta name="description" content={META.description} />
        <meta name="author" content={META.author} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={META.url} />
        <meta property="og:title" content={META.title} />
        <meta property="og:description" content={META.description} />
        <meta property="og:image" content={META.image} />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={META.url} />
        <meta property="twitter:title" content={META.title} />
        <meta property="twitter:description" content={META.description} />
        <meta property="twitter:image" content={META.image} />

        <link rel="canonical" href={META.url} />
      </Helmet>
      <HeroSection />
      <ProjectsSection />
      <ServicesSection />
      <AboutUsSection />
      <ContactUsSection />
      <FooterSection />
    </main>
  );
};

export default Home;
